import { Chip } from "@mui/material";
import moment from "moment";

export function DeleteIndicator({ eventData }) {
    return <Chip color='error' disabled sx={{ height: "22px" }} variant='filled' size='small' label={`Eliminado ${moment(eventData.updatedAt).format("DD/MM/YYYY")}`} />;
}
